import { Box, Grid, Modal, Stack } from "@mui/material";
import * as React from "react";
import { ProductType } from "../../../all-types";
import { ProductPopup } from "../components";
import ProductCard from "../components/product-card";

interface IProductPanelProps {
  products: ProductType[];
  currentTab: string;
  selectedProduct: ProductType | null;
  isPopupOpen: boolean;
  openPopUp: (p: ProductType) => void;
  closePopUp: () => void;
  editIndex: number | null;
}

const ProductPanel: React.FC<IProductPanelProps> = React.memo(
  ({
    products,
    currentTab,
    selectedProduct,
    isPopupOpen,
    openPopUp,
    closePopUp,
    editIndex,
  }) => {
    const popupStyle = {
      position: "absolute" as "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 450,
      boxShadow: 24,
    };

    return (
      <>
        <Grid container spacing={1} p={0.5} justifyContent={"center"}>
          {products.map((product) => (
            <Stack key={product._id} m={0.5}>
              <ProductCard item={product} handleOpen={openPopUp} />
            </Stack>
          ))}
        </Grid>
        <Modal open={isPopupOpen} onClose={closePopUp}>
          <Box sx={{ ...popupStyle }}>
            {selectedProduct && (
              <ProductPopup
                product={selectedProduct}
                exit={closePopUp}
                currentTab={currentTab}
                editIndex={editIndex}
              />
            )}
          </Box>
        </Modal>
      </>
    );
  },
  (prevProps, nextProps) => {
    // Prevent re-render if products are the same
    return (
      prevProps.products === nextProps.products &&
      prevProps.isPopupOpen === nextProps.isPopupOpen &&
      prevProps.selectedProduct === nextProps.selectedProduct &&
    //   prevProps.currentTab === nextProps.currentTab &&
      prevProps.editIndex === nextProps.editIndex
    );
  }
);

export { ProductPanel };
